<div class="status-message">
	<div class="status-message-content">
		<mnt-illustration [name]="illustration"></mnt-illustration>
		<div class="status-message-content-text mb-auto">
			<h1 class="heading-small">{{ title }}</h1>
			<p class="body-large">{{ body }}</p>
		</div>

		<ng-content select="status-message-content"></ng-content>
	</div>
</div>
@if(footerButtonProps) {
	<mnt-button
		class="w-100 mt-auto"
		[label]="footerButtonProps.label"
		[variant]="footerButtonProps.variant || 'emphasis'"
		[color]="footerButtonProps.color || 'primary'"
		[size]="footerButtonProps.size || 'large'"
		full-width
		(click)="handleFooterButtonClick()"
	></mnt-button>
}